import * as React from 'react';
import Button from '@telia-front/button';
import Image from '@telia-front/image';
const ImageZoom = (props) => {
    const { className } = props;
    const BEM = () => {
        const classArray = ['image-zoom'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("div", { className: BEM() },
        React.createElement(Image, Object.assign({}, props.image)),
        React.createElement(Button, { onClick: props.onClick, className: "image-zoom__button", variant: "secondary", icon: "#zoom-in", text: props.buttonText, ref: props.buttonRef, url: props.url })));
};
export default ImageZoom;
